const BLOCKED_REDIRECT_PATHS = ["/login", "/", "/expired", "/callback"];

// El path que se guarda incluye query y hash (`handleErrorAxios` guarda
// `pathname + search`), asi que hay que comparar el pathname pelado: con el
// string completo, un "/callback?code=..." se colaba en la lista y el login
// terminaba redirigiendose a si mismo. Como es la misma ruta y solo cambia el
// query, vue-router reusa el componente y `mounted()` no vuelve a correr: la
// vista se queda en el spinner sin volver a llamar al backend.
export const isSafeRedirectPath = (path) => {
    if (typeof path !== "string" || !/^\/(?!\/)/.test(path)) {
        return false;
    }
    const [pathname] = path.split(/[?#]/);
    return !BLOCKED_REDIRECT_PATHS.includes(pathname);
};
